import React, { useState } from "react";
import PropTypes from "prop-types";
import FooterAccordion from "@/components/FooterAccordion";
import NavItems from "@/components/NavItems";
import styles from "./index.module.scss";
import { FaFacebookF, FaInstagram, FaTiktok, FaTwitter } from "react-icons/fa";
import { TfiYoutube } from "react-icons/tfi";
import Chat from "../Chat";
import { applyLocaleToUrl } from "@/utils/formatters";
import { useRouter } from "next/router";
import PrintFooter from "@/components/CustomComponents/PrintFooter";

const FooterSection = ({
  navData = [],
  copyRightLinks = [],
  chatUrl = "",
  chatList = [],
}) => {
  const router = useRouter();
  const { locale } = router;
  const [openKey, setOpenKey] = useState();

  const handleToggle = key => {
    setOpenKey(openKey !== key ? key : null);
  };

  return navData ? (
    <>
      <div
        className={`hidden min-[821px]:block bg-[#232323] ${styles.footerContainer}`}
      >
        <section className="w-full">
          <div
            className={`${styles["footerSubContainer"]} flex-none justify-start sm:flex`}
          >
            {navData?.map(item => (
              <div
                className={`${styles["footerList"]} first:pt-6 sm:first:pt-0`}
                key={item?.sys?.id}
              >
                <div
                  className={`${styles["footerHeading"]} mt-[30px] mb-[23px] mx-0 text-footertext uppercase cursor-default text-[#e5e5e5]`}
                >
                  {item?.fields?.heading}
                </div>
                {item?.fields?.navItems.map((navItem, key) => (
                  <NavItems
                    key={navItem?.sys?.id || key}
                    navItem={navItem}
                    classNames={`${styles["footerSubHeading"]} text-footermenutext hover:text-white cursor-pointer`}
                    linkClass={`${styles["footerLink"]} text-[17px] text-[#bebebe] !font-[NotoSansRegular] flex lg:p-[4px] w-full text-footermenutext hover:text-white cursor-pointer font-[500]`}
                  />
                ))}
              </div>
            ))}
          </div>
        </section>
        <div className="footer-copyright">
          <ul className="footer-nav-items">
            {copyRightLinks?.map(link => (
              <li key={link?.fields?.label}>
                <a
                  href={applyLocaleToUrl(link?.fields?.url, locale)}
                  id={
                    link?.fields?.label === "Cookies Settings"
                      ? "ot-sdk-link"
                      : ""
                  }
                  className={
                    link?.fields?.label === "Cookies Settings"
                      ? "ot-sdk-show-settings cursor-pointer"
                      : ""
                  }
                  target={
                    link?.fields?.openerType === "New Tab" ? "_blank" : "_self"
                  }
                >
                  {link?.fields?.label}
                </a>
              </li>
            ))}
          </ul>
        </div>
      </div>
      <div className={`hidden max-[820px]:block bg-[#232323] print:hidden`}>
        <section className="w-full">
          <div className="flex-none justify-evenly">
            {navData?.map((item, index) => (
              <FooterAccordion
                key={item?.sys?.id || index}
                item={item}
                isActive={true}
                header={item?.fields?.heading}
                handleToggle={handleToggle}
                open={openKey === item?.fields?.heading}
              >
                {item?.fields?.navItems.map((navItem, key) => (
                  <React.Fragment key={navItem?.sys?.id || key}>
                    <NavItems
                      navItem={navItem}
                      data-te-collapse-item
                      id="collapseExample"
                      classNames="text-footermenutext hover:text-white cursor-pointer font-['NotoSansRegular'] text-[14px]"
                      linkClass={`${styles["footerAccordionLink"]} flex lg:p-[4px] w-full text-footermenutext px-[20px] py-[8px]`}
                    />
                    {/* <div className="border-b-[1px] border-[#666]" /> */}
                  </React.Fragment>
                ))}
              </FooterAccordion>
            ))}
            <div className="min-[819px]:block mx-auto max-w-full px-5 py-6 bg-[#232323]">
              <h4 className="text-[20px] uppercase mb-4 font-[NotoSansRegular,_Helvetica] text-[#e5e5e5]">
                Follow Us
              </h4>
              <div className="flex gap-4">
                <a
                  href="https://www.facebook.com/kohlerthailand"
                  target="_blank"
                  className="w-[30px] mr-[10px] h-[30px] bg-[#999] rounded-md flex items-center justify-center text-black"
                >
                  <FaFacebookF className="pl-[5px] h-[20px] w-[20px] text-[#232323]" />
                </a>
                <a
                  href="https://www.youtube.com/kohlerthailand"
                  target="_blank"
                  className="w-[30px] mr-[10px] h-[30px] bg-[#999] rounded-md flex items-center justify-center text-black"
                >
                  <TfiYoutube className="h-[20px] w-[20px] text-[#232323]" />
                </a>
              </div>
            </div>
          </div>
        </section>

        <div className={styles["mobile-footer-copyright"]}>
          <ul className={styles["mobile-footer-nav-items"]}>
            {copyRightLinks?.map(link => (
              <li key={link?.fields?.label}>
                <a
                  href={applyLocaleToUrl(link?.fields?.url, locale)}
                  id={
                    link?.fields?.label === "Cookies Settings"
                      ? "ot-sdk-link"
                      : ""
                  }
                  className={
                    link?.fields?.label === "Cookies Settings"
                      ? "ot-sdk-show-settings"
                      : ""
                  }
                  target={
                    link?.fields?.openerType === "New Tab" ? "_blank" : "_self"
                  }
                >
                  {link?.fields?.label}
                </a>
              </li>
            ))}
          </ul>
        </div>
      </div>
      <PrintFooter />
      <Chat chatUrl={chatUrl} chatList={chatList} />
    </>
  ) : null;
};

FooterSection.propTypes = {
  navData: PropTypes.arrayOf(
    PropTypes.shape({
      sys: PropTypes.shape({
        id: PropTypes.string,
      }),
      fields: PropTypes.shape({
        heading: PropTypes.string,
        navItems: PropTypes.arrayOf(PropTypes.shape({})),
      }),
    })
  ),
  copyRightLinks: PropTypes.arrayOf(
    PropTypes.shape({
      fields: PropTypes.shape({
        label: PropTypes.string,
        url: PropTypes.string,
      }),
    })
  ),
};

export default FooterSection;
